import React from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import ArrowForward from '@mui/icons-material/ArrowForward'

import { SectionProps } from '../../types/form'
import { REJECT_REASON } from '../../enums/reject-reason'


const Section9 = (props: SectionProps) => {

    const { isRejected, rejectReason } = props

    /**
     * RENDER COMPONENT
     */
    return (
        <Box>
            <Typography variant={'h2'} children={'Conclusão'} />

            <Box mb={'20px'}>
                {isRejected ? (
                    rejectReason === REJECT_REASON.RECENT_ENROLLMENT ? (
                        <Typography variant={'body1'}>
                            Infelizmente nesse momento seu currículo não foi
                            selecionado. Agradecemos seu interesse e ficamos à
                            disposição para novas oportunidades. Você poderá se
                            candidatar novamente em 6 meses.
                            <br />
                            Desejamos um excelente dia! ☺️
                        </Typography>
                    ) : (
                        <Typography variant={'body1'}>
                            Prezado candidato, identificamos que você se
                            candidatou recentemente. O prazo para realizar uma
                            nova candidatura é após o período de 6 meses.
                        </Typography>
                    )
                ) : (
                    <Typography variant={'body1'}>
                        Legal! Seu perfil atende os requisitos de nossa vaga,
                        iremos avaliar seu cadastro e entraremos em contato
                        pelos telefones registrados por você. A Marvel agradece
                        seu contato.
                    </Typography>
                )}
            </Box>

            <Stack direction={'row'} justifyContent={'end'} mt={5}>
                <Button
                    variant={'contained'}
                    onClick={() => {
                        window.location.href = 'https://marvel.com.br/'
                    }}
                    endIcon={<ArrowForward fontSize={'small'} />}
                    children={'Finalizar'}
                />
            </Stack>
        </Box>
    )
}

export default Section9
